<template>
	<div class="psv">
		<div class="psv__elm">
			<!-- //////////////// -->
			<!-- PAYMENT SUCCESS -->
			<SuccessPayment />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import SuccessPayment from "@/components/payment/SuccessPayment.vue";
import { mapActions, mapGetters } from "vuex";
import { payOptionsRenewalAction } from "@/store/payment/actions";

@Options({
	components: { SuccessPayment },

	computed: {
		...mapGetters("paymentModule", {
			paySuccess: "paySuccessGetters",
			payOptionsSuccess: "payOptionsSuccessGetters",
		}),
	},

	methods: {
		...mapActions("paymentModule", [
			"paySuccessAction",
			"payOptionsSuccessAction",
			"payOptionsRenewalAction",
		]),
	},
})
export default class PaymentSuccessView extends Vue {
	public PAYMENT_TYPE = {
		BALANCE: 0,
		CHANNEL: 1,
		OPTIONS: 3,
	};

	// ************************************************************
	// Define mapGetters
	public paySuccess: { id: number };
	public payOptionsSuccess: { id: number };

	// ************************************************************
	// Define mapActions
	public paySuccessAction!: (payload: { id: number }) => Promise<void>;
	public payOptionsSuccessAction!: (payload: {
		id: number;
		instanceId: number;
		newExpired: number;
	}) => Promise<void>;

	public payOptionsRenewalAction!: (payload: {
		id: number;
		instanceId: number;
		newExpired: number;
	}) => Promise<void>;

	/**
	 * Hook mounted
	 */
	public async mounted() {
		const orderId = Number(this.$route.params.orderId);
		const payType = Number(this.$route.params.payType);
		const newExpired = Number(this.$route.params.newExpired);
		const instanceId = Number(this.$route.params.instanceId);
		let paySuccessId = 0;

		switch (true) {
			// Этот блок сработает, если мы купили каналы
			case payType === this.PAYMENT_TYPE.BALANCE:
				// После успешной оплаты на сайте TBank, отправляем запрос на смену статуса в таблице payment.
				// Также выполняется пополнение баланса
				await this.paySuccessAction({ id: orderId });
				paySuccessId = this.paySuccess.id;
				break;
			// Этот блок сработает, если мы купили каналы
			case payType === this.PAYMENT_TYPE.CHANNEL:
				// После успешной оплаты на сайте TBank, отправляем запрос на смену статуса в таблице payment.
				// Также выполняется активация купленных кагалов
				await this.paySuccessAction({ id: orderId });
				paySuccessId = this.paySuccess.id;
				break;
			// Этот блок сработает, если мы купили опции
			case payType === this.PAYMENT_TYPE.OPTIONS:
				// После успешной оплаты на сайте TBank, отправляем запрос на смену статуса в таблице payment
				await this.payOptionsSuccessAction({
					id: orderId,
					instanceId: instanceId,
					newExpired: newExpired,
				});
				// Добавляем опции, которые хранятся в payment_data.
				// Еще нужно проверить опции, которые уже были куплены.
				await this.payOptionsRenewalAction({
					id: orderId,
					instanceId: instanceId,
					newExpired: newExpired,
				});

				paySuccessId = this.payOptionsSuccess.id;
				break;
		}

		if (paySuccessId === 0) {
			this.redirect("page-not-found");
		}
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public redirect(routeName: string, id?: number) {
		this.$router.push({ name: routeName, params: { id: id } });
	}
}
</script>

<style scoped lang="scss">
.psv {
	display: flex;
	justify-content: center;

	&__elm {
		padding-top: 24px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		max-width: 649px;
	}

	@media screen and (max-width: 768px) {
		&__elm {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			padding: 12px;
			min-width: 100px;
		}
	}
}
</style>
